import { BooleanRule, NotificationRule } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { put } from './request';

const SERVICE_PATH = 'rest/resource/notification-rule';
const updateNotificationRule = (notificationRule: NotificationRule) =>
    put<boolean>(`${CONTEXT_PATH}/${SERVICE_PATH}`, notificationRule);

export const toggleBooleanNotificationRule = (
    notificationRule: BooleanRule | undefined,
    enabled: boolean,
): Promise<boolean> => updateNotificationRule({ ...notificationRule, enabled } as BooleanRule);
